<template>
  <div>
    <div class="topbar">
      <div class="brand"><span class="dot"></span>我的</div>
    </div>
    <div class="content">
      <div class="card tap" @click="handleLoginClick">
        <div class="expert">
          <div class="avatar-lg">{{ loggedIn ? "我" : "?" }}</div>
          <div class="meta">
            <div class="name">{{ loggedIn ? phoneMasked : "点击登录" }}</div>
            <div class="title" v-if="!loggedIn">登录后查看订单、预约专家</div>
          </div>
        </div>
      </div>

      <div class="card tap" @click="goOrders">
        <div class="row">
          <div style="font-weight: 600">我的订单</div>
          <div class="muted">&#8250;</div>
        </div>
      </div>

      <div class="card tap" @click="goReferrals">
        <div class="row">
          <div style="font-weight: 600">我的推荐</div>
          <div class="muted">&#8250;</div>
        </div>
      </div>

      <button class="btn secondary" v-if="loggedIn" @click="logout" style="margin-top: 20px">
        退出登录
      </button>
    </div>
  </div>
</template>

<script>
import { getUserInfo, isLogin, phoneMask, removeToken, removeUserInfo } from "@/utils/common.js";
import { requireLogin } from "@/utils/requireLogin.js";

export default {
  name: "My",
  data() {
    return {
      loggedIn: false,
    };
  },
  computed: {
    phoneMasked() {
      let phone = getUserInfo("mobile") || getUserInfo("phone");
      return phoneMask(phone) || "已登录";
    },
  },
  created() {
    this.refreshLoginState();
  },
  activated() {
    this.refreshLoginState();
  },
  methods: {
    refreshLoginState() {
      this.loggedIn = isLogin();
    },
    handleLoginClick() {
      if (this.loggedIn) return;
      requireLogin(() => {
        this.refreshLoginState();
      });
    },
    goOrders() {
      requireLogin(() => {
        this.$router.push("/order/list");
      });
    },
    goReferrals() {
      requireLogin(() => this.$router.push("/referral/list"));
    },
    logout() {
      removeToken();
      removeUserInfo();
      this.loggedIn = false;
    },
  },
};
</script>
